import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import Notification from "../../../../components/common/notification/Notification";
import { deleteReferrerAction } from "../../../../store/reducers/referrerSlice";

interface DeleteUserPopupProps {
  title?: string;
  open?: boolean;
  selectUser?: any;
  onHide?: () => void;
  clientDetails?: any;
  setFormData?: any;
  formData?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
}
const DeleteUser: React.FC<DeleteUserPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset,selectUser,title
}) => {


  const dispatch = useDispatch();
  const classes = useStyles();
  const submitHandler = () => {
    dispatch(deleteReferrerAction(selectUser));
  
  };
  const closeModel = () => {
    setAlertModelShow(false);
  };
 
  return (
    <Popup
      open={alertModalShow}
      title={'Delete Referrer'}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={'xs'}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
        <Notification />
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure you want to delete this referrer ?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default DeleteUser;
